export default {
  guests_pay: 'Clienții plătesc {{amount}} la finalizarea comenzii (cel mai recent curs de schimb).',
  missing_rate: 'Nu există încă un curs de schimb pentru {{currency}}, deci clienții plătesc {{amount}} neconvertit.',
};
